import { app } from "js/namespaces";
import { UIController } from "js/editor/dialogs/UIController";
import { appSearchHost } from "js/config";

const fullTextSearchApi = async function(query, searchEngineName, fields = [], filters, group, page) {
    // OR CONDITION CAN BE REMOVED AFTER MIGRATION

    const searchKeys = app.user.get("searchKeys") ?? {};
    const workspaceKeys = searchKeys[UIController.getWorkspaceId()] ?? {};
    const bearerToken = workspaceKeys[`${searchEngineName}-private-key`] ?? workspaceKeys[`${searchEngineName}-public-key`];

    const body = { query };

    if (fields.length) {
        body.search_fields = fields.reduce((acc, cur) => {
            acc[cur] = {};
            return acc;
        }, {});
    }

    if (filters) {
        body.filters = filters;
    }

    if (group) {
        body.group = group;
    }

    body.page = page || { size: 500 };

    const res = await fetch(`${appSearchHost}engines/${searchEngineName}/search`, {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
            "Content-Type": "application/json",
            //the bearer is unique to each user, each view, and each workspace
            Authorization: `Bearer ${bearerToken}`
        }
    });

    const data = await res.json();

    if (data.errors) {
        throw data.errors;
    }

    return data.results;
};

export { fullTextSearchApi };
